import { render, staticRenderFns } from "./TransportSolicCard.vue?vue&type=template&id=70d081dc&scoped=true&"
import script from "./TransportSolicCard.vue?vue&type=script&lang=js&"
export * from "./TransportSolicCard.vue?vue&type=script&lang=js&"
import style0 from "./TransportSolicCard.vue?vue&type=style&index=0&id=70d081dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d081dc",
  null
  
)

export default component.exports